import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/certificate/reviews-1.jpg'
import _imports_1 from '../assets/img/certificate/reviews-2.jpg'
import _imports_2 from '../assets/img/certificate/reviews-3.jpg'
import _imports_3 from '../assets/img/certificate/reviews-4.jpg'
import _imports_4 from '../assets/img/certificate/reviews-5.jpg'
import _imports_5 from '../assets/img/certificate/reviews-6.jpg'
import _imports_6 from '../assets/img/certificate/reviews-7.jpg'
import _imports_7 from '../assets/img/certificate/reviews-8.jpg'
import _imports_8 from '../assets/img/certificate/reviews-9.jpg'
import _imports_9 from '../assets/img/certificate/reviews-10.jpg'
import _imports_10 from '../assets/img/certificate/reviews-11.jpg'
import _imports_11 from '../assets/img/certificate/reviews-12.jpg'
import _imports_12 from '../assets/img/certificate/reviews-13.jpg'
import _imports_13 from '../assets/img/certificate/reviews-14.jpg'
import _imports_14 from '../assets/img/certificate/reviews-15.jpg'
import _imports_15 from '../assets/img/certificate/reviews-16.jpg'
import _imports_16 from '../assets/icons/close_icon.svg'


const _hoisted_1 = { class: "px-200px <xl:px-100px max-w-1440px mx-auto mt-70px mb-50px <sm:px-0 <sm:w-full <sm:mt-35px" }
const _hoisted_2 = {
  class: "hover:fill-hex-6664D6 fill-black",
  src: _imports_16,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_block = _resolveComponent("top-block")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_top_block, {
        close: "",
        class: "sm:hidden"
      }),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"text-48px uppercase font-500 mb-10px &lt;sm:mx-50px &lt;sm:mb-5px &lt;sm:text-18px\" data-v-36a19632> Сертификаты </div><div class=\"text-24px uppercase mb-55px &lt;sm:mx-50px &lt;sm:text-14px\" data-v-36a19632> только надежные и проверенные банки </div><div class=\"flex w-full &lt;sm:block &lt;sm:px-50px\" data-v-36a19632><div class=\"mr-100px img-col &lt;sm:mr-0\" data-v-36a19632><img src=\"" + _imports_0 + "\" data-v-36a19632><img src=\"" + _imports_1 + "\" data-v-36a19632><img src=\"" + _imports_2 + "\" data-v-36a19632><img src=\"" + _imports_3 + "\" data-v-36a19632><img src=\"" + _imports_4 + "\" data-v-36a19632><img src=\"" + _imports_5 + "\" data-v-36a19632><img src=\"" + _imports_6 + "\" data-v-36a19632><img src=\"" + _imports_7 + "\" data-v-36a19632></div><div class=\"img-col\" data-v-36a19632><img src=\"" + _imports_8 + "\" data-v-36a19632><img src=\"" + _imports_9 + "\" data-v-36a19632><img src=\"" + _imports_10 + "\" data-v-36a19632><img src=\"" + _imports_11 + "\" data-v-36a19632><img src=\"" + _imports_12 + "\" data-v-36a19632><img src=\"" + _imports_13 + "\" data-v-36a19632><img src=\"" + _imports_14 + "\" data-v-36a19632><img src=\"" + _imports_15 + "\" data-v-36a19632></div></div>", 3))
    ]),
    _createVNode(_component_router_link, {
      class: "fixed top-50vh right-200px <xl:right-40px <sm:hidden",
      to: "/"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
          [_directive_svg_inline]
        ])
      ]),
      _: 1
    })
  ]))
}